import { v4 as genUuid } from "uuid";
import { AssetType } from "@thenounproject/lingo-core";
import {
  generateInsertPositionForUploads,
  getItemData,
  UploadAction,
  type InsertPosition,
} from "@actions/uploads";
import { createAsyncAction } from "../actionCreators";
import { enqueueUpload } from "../uploads/enqueueUpload";

type Color = {
  name?: string;
  hue: number;
  saturation: number;
  brightness: number;
  alpha: number;
  cmyk: string;
  pms: string;
  coverage: number;
};

type Args = {
  colors: Color[];
  insertPosition: InsertPosition;
};

const [useBatchCreateColorAssets, batchCreateColorAssets] = createAsyncAction(
  "assets/batchCreateColors",
  ({ colors, insertPosition: startingInsertPosition }: Args, thunkApi) => {
    const batchId = genUuid();
    const insertPosition = generateInsertPositionForUploads(colors.length, startingInsertPosition);
    const { spaceId } = insertPosition;

    colors.forEach(providedColor => {
      const { name, ...color } = providedColor;
      const { item } = getItemData(insertPosition);

      const uploadAction: UploadAction = {
        upload: {
          id: genUuid().toUpperCase(),
          batchId,
          status: "pending",
          name: name || "Color",
          type: AssetType.color,
          insertPosition,
          isAsset: true,
        },
        requestData: {
          endpoint: "assets",
          method: "POST",
          data: {
            space_id: spaceId,
            type: AssetType.color,
            name,
            colors: [color],
            item,
          },
        },
      };

      thunkApi.dispatch(enqueueUpload(uploadAction));
    });

    return Promise.resolve();
  }
);

export default useBatchCreateColorAssets;
export { batchCreateColorAssets };
